function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 66.26L256.804.56l-85.511 65.7L85.782.56.272 66.26"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 78.605l-85.51-65.7-85.511 65.7-85.511-65.7-85.51 65.7"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 90.95l-85.51-65.699-85.511 65.699-85.511-65.7-85.51 65.7"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 103.295l-85.51-65.699-85.511 65.699-85.511-65.699-85.51 65.699"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 115.64l-85.51-65.699-85.511 65.699-85.511-65.699L.272 115.64"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 127.985l-85.51-65.699-85.511 65.699-85.511-65.699-85.51 65.699"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 140.33l-85.51-65.699-85.511 65.7-85.511-65.7-85.51 65.7"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 152.675l-85.51-65.699-85.511 65.7-85.511-65.7-85.51 65.7"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 165.02l-85.51-65.699-85.511 65.7-85.511-65.7-85.51 65.7"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 177.365l-85.51-65.699-85.511 65.7-85.511-65.7-85.51 65.7"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 189.71l-85.51-65.7-85.511 65.7-85.511-65.7-85.51 65.7"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 202.054l-85.51-65.698-85.511 65.698-85.511-65.698-85.51 65.698"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.314 214.4l-85.51-65.7-85.511 65.7-85.511-65.7-85.51 65.7"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 343 215"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default __webpack_public_path__ + "static/media/parallel-lines-2-mobile.e018ec82.svg";
export { SvgComponent as ReactComponent };